import {
  DELETE_CRS_RISK_INDICATOR_THRESHOLD,
  DELETE_CRS_RISK_INDICATOR_THRESHOLD_FAIL,
  DELETE_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS,
  GET_CRS_RISK_INDICATORS,
  GET_CRS_RISK_INDICATORS_FAIL,
  GET_CRS_RISK_INDICATORS_SUCCESS,
  GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES,
  GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES_FAIL,
  GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES_SUCCESS,
  GET_CRS_RISK_INDICATOR_THRESHOLDS,
  GET_CRS_RISK_INDICATOR_THRESHOLDS_FAIL,
  GET_CRS_RISK_INDICATOR_THRESHOLDS_SUCCESS,
  PUT_CRS_RISK_INDICATOR_THRESHOLD,
  PUT_CRS_RISK_INDICATOR_THRESHOLD_FAIL,
  PUT_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS,
  UPDATE_CRS_RISK_INDICATOR_THRESHOLD,
  UPDATE_CRS_RISK_INDICATOR_THRESHOLD_FAIL,
  UPDATE_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS,
  POST_RISK_INDICATOR_TRIGGER,
  POST_RISK_INDICATOR_TRIGGER_FAIL,
  POST_RISK_INDICATOR_TRIGGER_SUCCESS
} from '../../actions/crs/crsRiskIndicator';

export const initialState = {
  riskIndicators: { isLoading: false, data: [], error: null },
  riskIndicatorsTrigger: { isLoading: false, data: [], error: null },
  riskIndicatorThresholds: { isLoading: false, data: [], error: null },
  putRiskIndicatorThreshold: { isLoading: false, data: {}, error: null },
  updateRiskIndicatorThreshold: { isLoading: false, data: {}, error: null },
  deleteRiskIndicatorThreshold: { isLoading: false, data: {}, error: null },
  riskIndicatorStaticProperties: { isLoading: false, data: {}, error: null }
};

function crsRiskIndicator(state = initialState, action) {
  switch (action.type) {
    // Get Risk Indicators
    case GET_CRS_RISK_INDICATORS:
      return {
        ...state,
        riskIndicators: { isLoading: true, data: [], error: null }
      };
    case GET_CRS_RISK_INDICATORS_SUCCESS:
      return {
        ...state,
        riskIndicators: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_RISK_INDICATORS_FAIL:
      return {
        ...state,
        riskIndicators: { isLoading: false, data: null, error: action.payload }
      };

    // Get Risk Indicator Thresholds
    case GET_CRS_RISK_INDICATOR_THRESHOLDS:
      return {
        ...state,
        riskIndicatorThresholds: { isLoading: true, data: [], error: null }
      };
    case GET_CRS_RISK_INDICATOR_THRESHOLDS_SUCCESS:
      return {
        ...state,
        riskIndicatorThresholds: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_RISK_INDICATOR_THRESHOLDS_FAIL:
      return {
        ...state,
        riskIndicatorThresholds: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    // Put Risk Indicator
    case PUT_CRS_RISK_INDICATOR_THRESHOLD:
      return {
        ...state,
        putRiskIndicatorThreshold: { isLoading: true, data: {}, error: null }
      };
    case PUT_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS:
      return {
        ...state,
        putRiskIndicatorThreshold: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case PUT_CRS_RISK_INDICATOR_THRESHOLD_FAIL:
      return {
        ...state,
        putRiskIndicatorThreshold: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    // Delete Risk Indicator
    case DELETE_CRS_RISK_INDICATOR_THRESHOLD:
      return {
        ...state,
        deleteRiskIndicatorThreshold: { isLoading: true, data: {}, error: null }
      };
    case DELETE_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS:
      return {
        ...state,
        deleteRiskIndicatorThreshold: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case DELETE_CRS_RISK_INDICATOR_THRESHOLD_FAIL:
      return {
        ...state,
        deleteRiskIndicatorThreshold: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    // Update Risk Indicator
    case UPDATE_CRS_RISK_INDICATOR_THRESHOLD:
      return {
        ...state,
        updateRiskIndicatorThreshold: { isLoading: true, data: {}, error: null }
      };
    case UPDATE_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS:
      return {
        ...state,
        updateRiskIndicatorThreshold: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case UPDATE_CRS_RISK_INDICATOR_THRESHOLD_FAIL:
      return {
        ...state,
        updateRiskIndicatorThreshold: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    // Post Risk Indicator Trigger
    case POST_RISK_INDICATOR_TRIGGER:
      return {
        ...state,
        riskIndicatorsTrigger: { isLoading: true, data: {}, error: null }
      };
    case POST_RISK_INDICATOR_TRIGGER_SUCCESS:
      return {
        ...state,
        riskIndicatorsTrigger: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case POST_RISK_INDICATOR_TRIGGER_FAIL:
      return {
        ...state,
        riskIndicatorsTrigger: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    // Get Risk Indicator Static Properties
    case GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES:
      return {
        ...state,
        riskIndicatorStaticProperties: {
          isLoading: true,
          data: {},
          error: null
        }
      };
    case GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES_SUCCESS:
      return {
        ...state,
        riskIndicatorStaticProperties: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES_FAIL:
      return {
        ...state,
        riskIndicatorStaticProperties: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    default:
      return state;
  }
}

export default crsRiskIndicator;
